import React from "react";
import "./SignUp.scss";
import Header from "../../Components/Header";
import Footer from "../../Components/Footer";

export default class SignUp extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount(){
  window.scrollTo(0, 0);
  }
  render(){
  return (
    <>
      <Header />
      <section className="sign-up">
        <div className="exploreCollections">
          <div className="container">
            <div className="section-title">
              <h2>SIGN UP</h2>
              <p>We just need a few more details from you.</p>
            </div>
            <div className="sign-up__form">
              <div className="form-group">
                <label>Full Name</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter your full name"
                />
              </div>
              <div className="form-group">
                <label>Email</label>
                <div className="form-control__wrapp">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter your email"
                  />
                </div>
              </div>
              <div className="form-group">
                <label>Mobile Number</label>
                <div className="form-control__wrapp">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter your mobile number"
                  />
                </div>
              </div>
              <div className="form-group__btn">
                <a href="/" className="button">
                  Sign Up
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
  }
}

//export default SignUp;
